import React from "react";
import ArrowRightIcon from "images/icons/arrow-right-icon.inline.svg";

export const Paginator = ({
  pagination,
  paginationCallback,
  children,
  paginatorContainerClass,
  paginationBtnContainerClass,
  paginationBtnClass,
  paginationShowFade,
  buttonLabel = "View more",
  isIcon = true
}) => {
  return (
    <>
      <div className={paginatorContainerClass}>
        <div
          className={`paginator-content relative bg-inherit ${
            pagination
              ? paginationShowFade
                ? "before:absolute before:w-[200vw] before:h-28 before:-right-24 before:md:-right-1/2 before:-bottom-10 before:md:-bottom-12 before:z-20 before:masked-overview before:masked-overview-top before:pagination-mask before:bg-inherit"
                : ""
              : ""
          }`}
        >
          {children}
        </div>
      </div>

      {pagination && (
        <div
          className={`pagination-cta-container ${paginationBtnContainerClass}`}
        >
          <button
            className={
              paginationBtnClass
                ? paginationBtnClass
                : "submit-button group flex justify-center items-center w-full md:w-auto py-2 px-12 md:mx-auto"
            }
            onClick={paginationCallback}
          >
            <p className=" font-bold pr-2">{buttonLabel}</p>
            {isIcon && (
              <ArrowRightIcon className="stroke-white planet:stroke-gray-darker planet:group-hover:stroke-green-standard group-hover:stroke-black-lighter rotate-90" />
            )}
          </button>
        </div>
      )}
    </>
  );
};

Paginator.defaultProps = {
  paginationBtnContainerClass:
    "pagination-cta absolute w-full pt-6 bottom-8 sm:py-0 md:bottom-20",
  paginationShowFade: false
};
